import { render, staticRenderFns } from "./uploadFiles.vue?vue&type=template&id=07f2c617&scoped=true"
import script from "./uploadFiles.vue?vue&type=script&lang=js"
export * from "./uploadFiles.vue?vue&type=script&lang=js"
import style0 from "./uploadFiles.vue?vue&type=style&index=0&id=07f2c617&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f2c617",
  null
  
)

export default component.exports